import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faCalendar, faChartLine, faUsers, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { Modal } from './Modal';
import './HelpModal.css';

export const CompetitionsHelpModal: React.FC<{ isOpen: boolean; onClose: () => void; }> = ({ isOpen, onClose }) => (
    <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
        <h2><FontAwesomeIcon icon={faTrophy} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />Competitions Guide</h2>
        <p style={{ fontSize: '1.1em', marginBottom: '24px' }}>🏆 This is where your legacy is built! Track your climb through leagues, conquer cup competitions, and cement your name in football history. Multiple tournaments = multiple paths to glory!</p>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faChartLine} style={{ marginRight: '8px', color: 'var(--info-color)' }} />League Standings</h3>
            <p><strong>Current league information:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>League Table:</strong> Teams ranked by points and goal difference</li>
                <li><strong>Current Position:</strong> Where your team stands (highlighted)</li>
                <li><strong>Points:</strong> Win = 3 points, Draw = 1 point, Loss = 0 points</li>
                <li><strong>Promotion/Relegation Zone:</strong> Teams moving up or down divisions</li>
            </ul>
            <p className="help-tip"><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '6px', color: 'var(--warning-color)' }} /><em>Finishing in the top spots gets promotion. Bottom teams face relegation.</em></p>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faTrophy} style={{ marginRight: '8px', color: 'var(--accent-text-color)' }} />Cup Competitions</h3>
            <p><strong>Cup tournament structure:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>Multiple Rounds:</strong> Knockout competition with progressively harder opponents</li>
                <li><strong>Prize Money:</strong> Significant rewards for advancing in cups</li>
                <li><strong>Final:</strong> Grand finale where the winner takes the trophy</li>
                <li><strong>Tournament Brackets:</strong> See upcoming matches and opponent routes</li>
            </ul>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faCalendar} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />Match Schedule</h3>
            <p><strong>Upcoming fixtures:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>Opponent:</strong> Who you're playing against</li>
                <li><strong>Home/Away:</strong> Match location</li>
                <li><strong>Week:</strong> When the match is scheduled</li>
                <li><strong>Competition:</strong> League or cup match</li>
            </ul>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faUsers} style={{ marginRight: '8px', color: 'var(--warning-color)' }} />Team Details</h3>
            <p><strong>Click on any team to see:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li>Squad composition and player ratings</li>
                <li>Team strength and formation</li>
                <li>Recent form and match results</li>
                <li>Key players and tactical approach</li>
            </ul>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '8px', color: 'var(--accent-text-color)' }} />Winning Strategy</h3>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li>📊 <strong>Watch the Promotion Race:</strong> Know where you stand - aim for top positions by season's end</li>
                <li>🏅 <strong>Don't Neglect Cups:</strong> Cup victories = big prize money + potential glory + moving up divisions!</li>
                <li>🎯 <strong>Scout Opponents:</strong> Study other teams to prepare your tactics and mentality</li>
                <li>💪 <strong>Tactical Rotation:</strong> Push hard in winnable matches, rotate against top teams to save fitness</li>
                <li>⬆️ <strong>League Climbing Pays:</strong> Higher divisions = better players attract to your club + bigger sponsorship deals</li>
                <li>🏆 <strong>Win Your League:</strong> Championship = automatic promotion to next division. Build momentum!</li>
            </ul>
        </div>

        <div className="modal-actions">
            <button className="button primary" onClick={onClose}>Let's Win!</button>
        </div>
    </Modal>
);
